import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { P11, Particles } from "./p11shared";
import { useP11Lang } from "./p11lang";

// Persoonlijke welcome na bevestigde inschrijving (kort, skippable).
export default function P11Welcome() {
  const nav = useNavigate();
  const { lang, tt } = useP11Lang();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/project11/me/dashboard").then(({ data }) => setData(data)).catch(() => nav("/project11/login"));
  }, [nav]);

  if (!data) return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label">…</span></div>;
  const name = (data.participant.first_name || "").toUpperCase();

  return (
    <div className="p11-root relative" data-testid="p11-welcome">
      <Particles />
      <main className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6">
        <div className="flex items-center gap-8 mb-8 p11-label">
          <span className="p11-label-yellow" data-testid="p11-welcome-label">{tt("reg_complete")}</span>
          <span>{lang === "nl" ? "TOEGANG" : "ENTRY"}</span>
          <span>{lang === "nl" ? "GOEDGEKEURD" : "APPROVED"}</span>
        </div>
        <h1 className="p11-h1 text-4xl md:text-6xl p11-reveal-anim" data-testid="p11-welcome-name">{tt("welcome_name")} {name}.</h1>
        <p className="mt-6 text-base" style={{ color: P11.gray2 }}>{tt("first_step")}</p>
        <div className="mt-12">
          <div className="p11-label">PROJECT 11*</div>
          <div className="p11-label mt-2" style={{ color: P11.gray }}>{tt("record_begins")}</div>
        </div>
        <button onClick={() => nav("/project11/identity", { replace: true })} className="p11-btn mt-14" data-testid="p11-welcome-continue">{tt("continue")}</button>
      </main>
    </div>
  );
}
